/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/camelcase */
/* global confirm */
import React from 'react'
import ReactDOM from 'react-dom'
import intl from 'react-intl-universal'
import { Provider } from 'react-redux'

import { storyControllerReducers } from '~/modules/contentComment/reducerTable'
import {
  storyLockedOrReadonlyAccessor,
  previousTab,
  setOnlyActiveTab,
} from '~/redux/appReducer'
import { addMultisiteFields } from '~/modules/services/story/multisiteMigration'
import setDefaultWebsite from '../services/story/setDefaultWebsite'
import setANSDefaults from '../services/story/setANSDefaults'
import { channels } from '../services/story'
import CONSTANTS from '~/constants'
import { SettingsProvider } from '~/reactapp/App/SettingsContext'
import { getStoryPubstack } from '~/api/story'
import {
  setCirculation,
  getCirculation,
  setStoryAns,
  leavingStoryAction,
} from '~/redux/storyData'
import { routeChangingAction } from '~/redux/routeReducer'
import { SiteSelectorV2 } from '../../reactapp/App/SiteSelectorV2'
import { FeaturesProvider } from '../../reactapp/App/FeaturesContext'

export default [
  'tabService',
  '$rootScope',
  '$scope',
  '$routeParams',
  '$location',
  '$window',
  'storyService',
  'authorService',
  'padlockService',
  '$ngRedux',
  'evidentlyService',
  StoryController,
]

export function Link(
  $rootScope,
  $ngRedux,
  picklistService,
  storyService,
  evidentlyService
) {
  return function ($scope, $el) {
    const reactRenderContainer = $el.find('#react-circulate-tab-body')[0]

    $scope.$on('$destroy', () =>
      ReactDOM.unmountComponentAtNode(reactRenderContainer)
    )

    function handleCirculationsChanged(selectedCirculations) {
      // Circulations will need to be created and removed from story object when the story is created to pass ANS validation.
      // This property should only exist on the template's data.
      $ngRedux.dispatch(setCirculation(selectedCirculations))
      renderCirculateTab()
    }

    function handleCanonicalWebsiteChanged(websiteId) {
      $ngRedux.dispatch(
        setStoryAns({
          storyAns: {
            ...$scope.story,
            canonical_website: websiteId,
            isDirty: true,
          },
          // Changing primary website should make the template dirty
          isDirty: true,
        })
      )
      renderCirculateTab()
    }

    function handleAppendContentRestrictionsPicklist(picklistItem) {
      picklistService
        .get()
        .picklists.content_restrictions.picklist.push(picklistItem)
      renderCirculateTab()
    }

    function handlePaywallStatusChanged(contentCode) {
      $ngRedux.dispatch(
        setStoryAns({
          storyAns: {
            ...$scope.story,
            content_restrictions: {
              ...$scope.story.content_restrictions,
              content_code: contentCode,
            },
            isDirty: true,
          },
          // Changing paywall status should make the template dirty
          isDirty: true,
        })
      )
      renderCirculateTab()
    }

    function renderCirculateTab() {
      if ($scope.websites.hash) {
        ReactDOM.render(
          <Provider store={$ngRedux}>
            <FeaturesProvider features={$rootScope.features}>
              <SettingsProvider settings={$rootScope.globalSettings}>
                <SiteSelectorV2
                  onCirculationsChange={handleCirculationsChanged}
                  isTemplate={true}
                />
              </SettingsProvider>
            </FeaturesProvider>
          </Provider>,
          reactRenderContainer
        )
      } else {
        ReactDOM.render(
          <div>
            <b>{intl.get('initialLoads.getWebsites.error')}</b>
            <br />
            {intl.get('circulation.tab.siteServiceError')}
          </div>,
          reactRenderContainer
        )
      }
    }
  }
}

const mapStateToThis = (state) => ({
  circulations: getCirculation(state),
  isLockedOrReadonly: storyLockedOrReadonlyAccessor(state),
})

function StoryController(
  tabService,
  $rootScope,
  $scope,
  $routeParams,
  $location,
  $window,
  storyService,
  authorService,
  padlockService,
  $ngRedux
) {
  $scope.intl = intl

  let unsubscribers = []

  unsubscribers.push($ngRedux.connect(mapStateToThis)($scope))

  // Custom Template Code
  $scope.currentPath = $location.path()

  // todo: remove this hot fix
  $rootScope.centerButtons = {}
  $scope.setVertState = (state) => {
    if ($scope.webskedIsDown && state.indexOf('websked') > -1) {
      return
    }

    // Hacking the interface.
    if (state !== 'revisions') {
      $scope.vertActive = state
    } else {
      storyService.save()
    }
    $rootScope.$broadcast('RIGHT_TAB_CHANGE', {
      vertActive: state,
    })
  }

  // stuff from route resolve
  $scope.webskedDisabled = window.org_settings.disableWebskedIntegration
  $scope.lockDetails = $scope.$resolve.initialLockState.lockDetails
  console.warn($scope.$resolve.initialLockState)
  $scope.picklists = $scope.$resolve.initialPicklistLoad.picklists
  $scope.companySettings = $scope.$resolve.initialSettingsLoad
  $scope.websites = $scope.$resolve.initialWebsiteLoad
  $scope.websked = $scope.$resolve.initialWebskedLoad
  $scope.webskedIsDown = $scope.websked.webskedDown

  const storyToSet = addMultisiteFields(
    $scope.$resolve.initialStoryLoad.story,
    $scope.websites.hash
  )
  const storyWithDefaults = setANSDefaults({
    story: storyToSet,
    orgSettings: $scope.companySettings,
    channels,
    websked: $scope.websked,
  })
  $scope.story = setDefaultWebsite(storyWithDefaults, $scope.websites.hash)

  // todo: daniel: uhhhhh
  // holy crap why do we need this?
  // i dunno why, but we do
  storyService.setStory($scope.story, false)
  $scope.isRevision = $scope.story.diffViewRevisionId // set from diff view
  $rootScope.requiresActions = !$scope.isRevision
  // $scope.vertActive = $scope.isRevision ? 'revisions' : 'toolbox'
  $scope.author = $scope.$resolve.initialStoryLoad.story.credits.by
  $scope.storyState = {}
  $scope.activeStory = $scope.story._id
  // moves content comments up or down
  $scope.forceHeight = 0
  // caches if we have already clicked on same comment
  $scope.focusedComment = -1

  unsubscribers.push(
    $rootScope.$on('SAVE_SUCCESS', (evt, details) => {
      $scope.activeStory = details.story._id
      storyService.isDirty(false)
      $('input.ng-dirty, textarea.ng-dirty').removeClass('ng-dirty')
    })
  )

  unsubscribers.push(
    $rootScope.$on('CONTENT_COMMENT', (info, action) => {
      if (storyControllerReducers[action.type]) {
        storyControllerReducers[action.type]({
          storyCtrl: $scope,
          storyService,
          comments: $scope.story.additional_properties.comments,
          action,
        })
      }
    })
  )

  unsubscribers.push(
    // Propagate story object updates from react components to angular:
    // 1. React component dispatches action: dispatch(setStoryAns({storyAns: ans, isDirty: true}))
    // 2. Redux updates angular story service: serviceResolver('storyService').setStory(ans, isDirty)
    // 3. Story service broadcasts event: $rootScope.$broadcast('STORY_SET', { story })
    // 4. StoryController updates its $scope value
    $rootScope.$on('STORY_SET', (evt, data) => {
      $scope.story = data.story
    })
  )

  $scope.setVertState($scope.isRevision ? 'revisions' : 'toolbox')

  // this is to give websked buttons the same story obj
  // todo: a root component should be fetching data and putting it
  // in rootscope, or something
  $rootScope.$broadcast('DISPATCH', {
    type: 'STORY_FETCH_SUCCESS',
    story: $scope.story,
  })

  $scope.activeTab = tabService.get({
    story: $scope.story,
  })
  // Call tabService.set to propagate TAB_CHANGE event.
  // A commont pattern around the code base is to watch for
  // both STORY_FETCH_SUCCESS and CHANGE_TAB to detect which tab is active.
  // This call would guarantee that ony CHANGE_TAB is necessary
  tabService.set($scope.activeTab)

  unsubscribers.push(
    $rootScope.$on('CHANGE_TAB', (sender, action) => {
      $scope.activeTab = action.tab.id
    })
  )

  if ($window.sessionStorage.getItem('set_tab'))
    $window.sessionStorage.removeItem('set_tab')

  // two way binding is not playing nice
  // with planning tab, so I need one way binding
  // that is manually updated in parent scope
  // with a callback

  $scope.updateModel = ({ model }) => {
    $scope.story = model
    storyService.setStory(model, true)
  }

  // TODO: Eric - Figure out a better way to disable everything....
  // Temp solution until we can figure out a better solution
  if (!$scope.lockDetails.isMyLock) {
    document.querySelector('body').classList.add('readonly')
  } else {
    document.querySelector('body').classList.remove('readonly')
  }

  // errors probably need to be displayed at the parent level
  // with some toastr notification or something
  // easier to have all errors that come in
  // via child tab components
  // to be bubbled up to the story container

  $scope.errorCapture = (e) => {
    console.log('[story]: error captured', e)
  }

  const pageHasUnsavedEdits = () => {
    return storyService.isDirty()
  }

  let displayBrowserWarningPrompt = true

  $scope.$on('$locationChangeStart', (event, next, current) => {
    const re = new RegExp(`${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/([^/]+)`)
    const nextMatch = next.match(re)
    const nextPage = nextMatch ? nextMatch[1] : ''
    const currMatch = current.match(re)
    const currPage = currMatch ? currMatch[1] : ''

    if (
      $scope.companySettings.showUnsavedWarningPrompt &&
      currPage !== nextPage
    ) {
      if (pageHasUnsavedEdits() && displayBrowserWarningPrompt) {
        if (confirm(intl.get('storyDirective.unsavedConfirm'))) {
          $window.location = next
          displayBrowserWarningPrompt = false
        } else {
          event.preventDefault()
          displayBrowserWarningPrompt = true
        }
      }
    }

    const userCancelledPageChange = event.defaultPrevented

    if (userCancelledPageChange) {
      const currentRouteArray = current
        .substring(current.indexOf('composer'))
        .split('/')
      const currentRoute =
        currentRouteArray[1] === 'edit'
          ? '/' + currentRouteArray[1] + '/:id/'
          : '/' + currentRouteArray[1]
      const params =
        currentRouteArray[1] === 'edit' ? { id: currentRouteArray[2] } : {}

      // revert state.appState.activeTab to current selected tab and state.route.current to the current page
      $ngRedux.dispatch(setOnlyActiveTab(previousTab($ngRedux.getState())))
      $ngRedux.dispatch(
        routeChangingAction({
          params,
          current: currentRoute,
        })
      )
    } else {
      $ngRedux.dispatch(leavingStoryAction())
      padlockService.cleanUp()
    }
  })

  $scope.overrideRevId = async () => {
    await getStoryPubstack($scope.story._id) // Fetch story again to get latest eTag
    storyService.save()
  }

  $scope.createNewBranch = (newBranchName) => {
    //  The new branch is created using PUT /story/:id, modifying the revision.branch property to the be the name of the new branch
    $scope.story.revision.branch = newBranchName
    storyService.saveAndRedirect(
      `story/${$scope.story._id}/branch/${newBranchName}`
    )
  }

  $scope.change = () => {
    storyService.isDirty(true)
  }

  window.onbeforeunload = function () {
    if (!displayBrowserWarningPrompt) {
      displayBrowserWarningPrompt = true
      return null
    }

    return $scope.companySettings.showUnsavedWarningPrompt &&
      pageHasUnsavedEdits()
      ? true
      : null
  }

  $scope.$on('$destroy', () => {
    window.onbeforeunload = null
    unsubscribers.forEach((f) => f())
    unsubscribers = []
  })

  $scope.openNote = () => {
    $scope.isOpen = true
    try {
      $scope.tempState = $scope.story.planning.internal_note
    } catch (e) {
      $scope.tempState = ''
    }
  }

  $scope.setNote = () => {
    $scope.isOpen = false
    storyService.setStoryProp(
      'planning.internal_note',
      $scope.story.planning.internal_note
    )
  }

  $scope.cancelNote = () => {
    try {
      if ($scope.tempState) {
        $scope.story.planning.internal_note = $scope.tempState
      } else {
        $scope.story.planning.internal_note = ''
      }
    } catch (e) {
      console.log(e + 'no data')
    }

    $scope.isOpen = false
  }
}
